import logger from '@root/src/libs/logger'
import axios from 'axios'
import OrderAppLib from 'dimorder-orderapp-lib'
import moment from 'moment'

import i18n from '@/i18n'
import customerApi from '@/libs/api/customerApi'
import dimorderApi from '@/libs/api/dimorderApi'

import actions from '../actions'
import ActionTypes from './ActionTypes'

/**
 * @function
 * @returns {ThunkFunction}
 */
export function init() {
  return async (dispatch) => {
    await dispatch(getIpInfo())

    // 初始化 i18n 語言
    dispatch(getPreferredLanguage())

    await dispatch(actions.user.init())
    await dispatch(actions.merchant.init())
    dispatch(restoreLang())
    dispatch(restoreAdLastPopDate())
    dispatch({ type: ActionTypes.INIT })
  }
}

export function getPreferredLanguage() {
  return (dispatch, getState) => {
    const locale = OrderAppLib.libs.createLocaleHelper({
      getCountryFromStore() {
        return getState().app?.ipInfo?.country || getState().app?.lang
      },
    })
    const preferredLanguage = locale.getPreferredLanguageCode()

    logger.log('[getPreferredLanguage]', { preferredLanguage })

    const langInit = localStorage.getItem('langInit')

    if (!langInit) {
      // 若沒有設定過語言，則設定 preferredLanguage 為預設語言
      localStorage.setItem('langInit', true)

      dispatch(changeLang(preferredLanguage))
    }
  }
}

export function getIpInfo() {
  return async (dispatch, getState) => {
    try {
      const response = await axios.get('https://ipinfo.io/json', { timeout: 3000 })
      const ipInfo = response.data
      logger.log('[getIpInfo]', { ipInfo })
      dispatch({
        type: ActionTypes.UPDATE_IP_INFO,
        payload: { ipInfo },
      })
    } catch (error) {
      logger.error(`[getIpInfo] error ${error?.message || error}`, { error })
    }
  }
}

/**
 * @function
 * @param {string?} lang
 * @returns {ThunkFunction}
 */
export function restoreLang() {
  return (dispatch) => {
    // restore from local storage
    const i18nextLng = localStorage.getItem('i18nextLng')
    // 沒有抓到就不要 restore
    if (!i18nextLng) return

    const apiLanguage = i18nextLng.slice(0, 2) // 'zh-TW' => 'zh'
    // update api language
    dimorderApi.instance()?.setLanguage(apiLanguage)
    customerApi?.setLanguage(apiLanguage)

    // update redux state
    dispatch({
      type: ActionTypes.UPDATE_LANG,
      payload: { lang: i18nextLng },
    })
  }
}

/**
 * @function
 * @param {string?} lang
 * @returns {ThunkFunction}
 */
export function changeLang(lang) {
  return async (dispatch, getState) => {
    const i18nextLng = lang
    // update default language
    localStorage.setItem('i18nextLng', i18nextLng)
    const apiLanguage = i18nextLng.slice(0, 2) // 'zh-TW' => 'zh'

    i18n.changeLanguage(lang)
    dimorderApi.instance()?.setLanguage(apiLanguage)
    customerApi?.setLanguage(apiLanguage)

    // update redux state
    dispatch({
      type: ActionTypes.UPDATE_LANG,
      payload: { lang: i18nextLng },
    })
  }
}

export function restoreAdLastPopDate() {
  return (dispatch, getState) => {
    const lastPopDate = localStorage.getItem('adLastPopDate')
    if (lastPopDate) {
      dispatch({
        type: ActionTypes.UPDATE_ADLASTPOPDATE,
        payload: lastPopDate,
      })
    }
  }
}

export function popAd() {
  return (dispatch, getState) => {
    const lastPopDate = getState().app.adPop.lastPopDate
    if (lastPopDate) {
      if (moment().startOf('day').diff(moment(lastPopDate).startOf('day'), 'day') >= 1) {
        dispatch({
          type: ActionTypes.POP_AD,
        })
        localStorage.setItem('adLastPopDate', moment())
        dispatch(restoreAdLastPopDate())
      }
    } else {
      dispatch({
        type: ActionTypes.POP_AD,
      })
      localStorage.setItem('adLastPopDate', moment())
      dispatch(restoreAdLastPopDate())
    }
  }
}

export function closeAd() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.CLOSE_AD,
    })
    dispatch(restoreAdLastPopDate())
  }
}
